import { getStitchedData } from "api/dataVisualisation/client";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import {
  DataDownloadModel,
  JsonDataDownloadModel,
} from "models/dataDownload/dataDownloadModel";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { RollingSystemDemandModel } from "models/rollingSystemDemand/rollingSystemDemandModel";

const maxDaysPerQuery = 7;

export const getRollingSystemDemandChartData = async (
  dateFilter: DateFilterModel
): Promise<RollingSystemDemandModel[]> => {
  const { data } = (await getStitchedData(
    "/demand/outturn/summary",
    {
      from: "From",
      to: "To",
    },
    dateFilter,
    maxDaysPerQuery
  )) as JsonDataDownloadModel<RollingSystemDemandModel>;

  return data;
};

export const getRollingSystemDemandDownloadData = async (
  dateFilter: DateFilterModel,
  format: DataDownloadFormat
): Promise<DataDownloadModel<RollingSystemDemandModel>> =>
  getStitchedData(
    "/generation/outturn",
    {
      from: "From",
      to: "To",
    },
    dateFilter,
    maxDaysPerQuery,
    {},
    format
  );
